'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _search = require('@alicd/next/lib/search');

var _search2 = _interopRequireDefault(_search);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dom2 = require('@alicd/next/lib/dom');

var _dom3 = _interopRequireDefault(_dom2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cruiFormItem = require('@alicd/crui-form-item');

var _cruiFormItem2 = _interopRequireDefault(_cruiFormItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var events = _dom3.default.events;

var SearchField = function (_React$Component) {
  (0, _inherits3.default)(SearchField, _React$Component);

  function SearchField(props) {
    (0, _classCallCheck3.default)(this, SearchField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchField.__proto__ || (0, _getPrototypeOf2.default)(SearchField)).call(this, props));

    _this._safeClickNode = [];
    _this._onDocumentClick = _this._onDocumentClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SearchField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleDocumentEvents();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.handleDocumentEvents();
    }
  }, {
    key: 'handleDocumentEvents',
    value: function handleDocumentEvents() {
      if (this.props.overlayVisible) {
        if (this.props.canCloseByOutSideClick && !this._documentEvents) {
          this._documentEvents = events.on(document, 'click', this._onDocumentClick);
        }
        return;
      }
      this.clearDocumentEvents();
    }
  }, {
    key: 'clearDocumentEvents',
    value: function clearDocumentEvents() {
      if (this._documentEvents) {
        this._documentEvents.off();
        this._documentEvents = null;
      }
    }
  }, {
    key: '_onDocumentClick',
    value: function _onDocumentClick(e) {
      this.initSafeNode();
      for (var i = 0; i < this._safeClickNode.length; i++) {
        var node = this._safeClickNode[i],
            target = e.target;
        if (node.contains(target) || node === target || !document.documentElement.contains(e.target)) {
          return;
        }
      }
      this.props.onRequestClose(e);
    }
  }, {
    key: 'initSafeNode',
    value: function initSafeNode() {
      var searchInput = _reactDom2.default.findDOMNode(this);
      this._safeClickNode = [searchInput];
      if (this.props.combox) {
        var combox = this.refs.combox;
        this._safeClickNode.push(combox);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          combox = _props.combox,
          bind = _props.bind,
          style = _props.style,
          inputStyle = _props.inputStyle,
          container = _props.container,
          showSearchBtn = _props.showSearchBtn,
          canCloseByOutSideClick = _props.canCloseByOutSideClick,
          other = (0, _objectWithoutProperties3.default)(_props, ['combox', 'bind', 'style', 'inputStyle', 'container', 'showSearchBtn', 'canCloseByOutSideClick']);
      var labelCol = other.labelCol,
          wrapperCol = other.wrapperCol,
          mapping = other.mapping,
          className = other.className,
          otherInput = (0, _objectWithoutProperties3.default)(other, ['labelCol', 'wrapperCol', 'mapping', 'className']);


      var comboxWrapped = canCloseByOutSideClick ? _react2.default.createElement(
        'div',
        { ref: 'combox', className: 'cn-search-combox-wrap' },
        combox
      ) : combox;
      return _react2.default.createElement(
        _cruiFormItem2.default,
        (0, _extends3.default)({}, other, { style: style }),
        _react2.default.createElement(_search2.default, (0, _extends3.default)({}, otherInput, { combox: comboxWrapped, style: inputStyle, className: !showSearchBtn ? "no-search-rt" : "" }))
      );
    }
  }]);
  return SearchField;
}(_react2.default.Component);

SearchField.propTypes = {
  canCloseByOutSideClick: _propTypes2.default.bool,
  onRequestClose: _propTypes2.default.func,
  showSearchBtn: _propTypes2.default.bool
};
SearchField.defaultProps = {
  canCloseByOutSideClick: false,
  onRequestClose: function onRequestClose() {},
  showSearchBtn: true
};
exports.default = SearchField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-search-field@0.0.10@@alicd/crui-search-field/lib/index.js
// module id = 659
// module chunks = 0